var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoFrameHandler(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 10,
    viewBox: "0 0 4 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.41667 9.5L1.41667 0.5C1.41667 0.367392 1.35521 0.240214 1.24581 0.146446C1.13642 0.0526781 0.988043 -3.22609e-08 0.833333 -2.54983e-08C0.678623 -1.87357e-08 0.53025 0.0526781 0.420854 0.146446C0.311458 0.240214 0.25 0.367392 0.25 0.5L0.25 9.5C0.25 9.63261 0.311458 9.75979 0.420854 9.85355C0.530251 9.94732 0.678624 10 0.833333 10C0.988043 10 1.13642 9.94732 1.24581 9.85355C1.35521 9.75979 1.41667 9.63261 1.41667 9.5ZM2.58333 0.5L2.58333 9.5C2.58333 9.63261 2.64479 9.75979 2.75419 9.85355C2.86358 9.94732 3.01196 10 3.16667 10C3.32138 10 3.46975 9.94732 3.57915 9.85355C3.68854 9.75979 3.75 9.63261 3.75 9.5L3.75 0.5C3.75 0.367391 3.68854 0.240214 3.57915 0.146446C3.46975 0.052678 3.32138 -1.34254e-07 3.16667 -1.27492e-07C3.01196 -1.20729e-07 2.86358 0.052678 2.75419 0.146446C2.64479 0.240214 2.58333 0.367391 2.58333 0.5Z",
    fill: "#070550"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoFrameHandler);
export default __webpack_public_path__ + "static/media/video-frame-handler.fccf2c2678f34951a780c85201fdaf74.svg";
export { ForwardRef as ReactComponent };